import styled from 'styled-components'
import media from 'styled-media-query'

export const CopyrightFooterContainer = styled.div`
  font-family: ${props => props.theme.font};
  font-size: 14px;
  width: 100%;
  height: 3.5rem;
  padding: 2rem 0;
  line-height: 1.7rem;
  color: ${props => props.theme.footer.desktop.copyright.text};
  justify-content: space-between;
  display: flex;

  ${media.lessThan('medium')`
    line-height: 2.7rem;
    flex-direction: column-reverse;
    color: ${props => props.theme.footer.mobile.copyright.text};
  `}
`

export const CopyrightText = styled.div``
export const CopyrightCRM = styled.div``
